export default __webpack_public_path__ + "static/media/icon-update-successful-check.6296d53a.svg";